import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Button from '@mui/material/Button';
import { useParams } from 'react-router-dom';
import { FormProvider, useForm, useFormContext, useWatch } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { isEmpty, some, values, isArray } from 'lodash';
import { useTranslation } from 'react-i18next';

import * as FormInputs from 'common-components/form-inputs';
import { Lists } from 'common-components/form-inputs/list-autocomplete';
import { useGetListsQuery } from 'app/apis/lists.api';

import { formToSearchParams } from '../search/search-utils';

const SearchForm = () => {
  const { getValues } = useFormContext();
  const navigate = useNavigate();
  const { lang } = useParams();
  const { t } = useTranslation();

  const formWatch = useWatch({
    name: ['committeeIds', 'typeIds', 'themeIds', 'reference', 'yearFrom', 'yearTo'],
  });

  const applySearch = () => {
    const searchParams = new URLSearchParams(formToSearchParams(getValues(), true));
    searchParams.set('mode', 'advanced');
    navigate(`/${lang}/instruments?${searchParams.toString()}`)
  };

  const searchEnabled = some(values(formWatch), x => isArray(x) ? !isEmpty(x) : !!x);

  return (
    <Grid container spacing={2} component="form" onSubmit={applySearch}>
      <Grid item xs={12} md={6}>
        <FormInputs.FormListAutocomplete
          name="typeIds"
          multiple
          listName={Lists.InstrumentTypes}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormInputs.FormListAutocomplete
          name="committeeIds"
          multiple
          listName={Lists.Committees}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormInputs.FormListAutocomplete
          name="themeIds"
          multiple
          listName={Lists.Themes}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <FormInputs.FormListAutocomplete
              name="yearFrom"
              listName={Lists.Years}
              label={t("from")}
            />
          </Grid>
          <Grid item xs={6}>
            <FormInputs.FormListAutocomplete
              name="yearTo"
              listName={Lists.Years}
              label={t("to")}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <FormInputs.FormTextField name={'reference'} fullWidth size="small" label={t('Title or reference')}/>
      </Grid>
      <Grid item xs={12} sx={{ textAlign: 'right' }}>
        <Button type="submit" disabled={!searchEnabled} variant="contained">
          {t('search')}
        </Button>
      </Grid>
    </Grid>
  )
};

const QuickSearch = () => {
  const { lang } = useParams();
  const { t } = useTranslation();
  const { data: lists, isLoading } = useGetListsQuery({ lang });
  const quickSearchForm = useForm({
    defaultValues: {},
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h2">
          {t('Quick Search')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        {isLoading && <Skeleton height={200}/>}
        {!isEmpty(lists) && (
          <FormProvider {...quickSearchForm}>
            <SearchForm/>
          </FormProvider>
        )}
      </Grid>
    </Grid>
  );
};

export default QuickSearch;
